import React from "react";
import "./TitleL1.scss";

function TitleL1({ children = "Default Text" }) {
  return <div className="title__L1">{children}</div>;
}

export default TitleL1;
